import React from 'react';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import CustomRouter from './router/CustomRouter';
import theme from './theme';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <CustomRouter />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
